import axios from "axios";
import store from "@/store";
import { GLOBAL } from "@/config/consts";
import router from "@/router";

const baseUrl = "";
const instanceAxios = axios.create({
  baseURL: baseUrl
});
const token = localStorage.getItem("token");

if (token) {
  instanceAxios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}
instanceAxios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const originalRequest = error.config;
    if (error.response.status !== 401) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
    if (
      error.config.url === "/token/refresh" ||
      error.response.message === "Account is disabled."
    ) {
      store.dispatch("logout");
      router.push("/login");

      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      return axios
        .post(GLOBAL.apiUrl.refresh_token, {
          refresh_token: localStorage.getItem("refresh_token")
        })
        .then(({ data }) => {
          const config = error.config;
          const token = data.token;
          const refreshToken = data.refresh_token;
          localStorage.setItem("token", token);
          localStorage.setItem("refresh_token", refreshToken);
          config.headers["Authorization"] = `Bearer ${token}`;
          instanceAxios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${token}`;

          return new Promise((resolve, reject) => {
            axios
              .request(config)
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          });
        })
        .catch(error => {
          Promise.reject(error);
        });
    }
  }
);

export default {
  // eslint-disable-next-line no-shadow
  install(Vue) {
    Vue.prototype.$axios = instanceAxios;
  }
};

export { instanceAxios };
